import { render, staticRenderFns } from "./PhieuThayDoiThongTin.vue?vue&type=template&id=bd52773c&scoped=true"
import script from "./PhieuThayDoiThongTin.vue?vue&type=script&lang=js"
export * from "./PhieuThayDoiThongTin.vue?vue&type=script&lang=js"
import style0 from "./PhieuThayDoiThongTin.vue?vue&type=style&index=0&id=bd52773c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd52773c",
  null
  
)

export default component.exports